import(/* webpackMode: "eager" */ "/var/www/academy-frontend/src/app/(teacher)/teacher/(auth)/layout.js");
